import { Form, InputGroup } from "react-bootstrap";
import "./Inputs.scss";
import { useState, useEffect } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Select from "react-select";
import { ImUpload2 } from "react-icons/im";
import ColorSchema from "../Color";
import CreatableSelect from "react-select/creatable";
import { PatternFormat } from "react-number-format";

const CustomInput: React.FC<{
  label?: string;
  placeholder?: string;
  inputSize?: "sm" | "lg" | "text" | undefined; //   lg/text/sm
  type: string; // text,number,password
  activate?: string; // disabled, readOnly, active
  plaintext?: boolean;
  inputType?: "input" | "textarea"; //input,textarea
  textErr?: string;
  labelClassName?: string;
  inputClassName?: string;
  inputContainer?: string;
  onChangeFunc?: (e: {}) => void;
  inputValue?: string;
}> = ({
  label = "",
  placeholder = "",
  inputSize = "sm",
  activate = "active",
  plaintext = false,
  type = "",
  inputType = "input",

  textErr = "",
  labelClassName = "",
  inputClassName = "",
  inputContainer = "",
  onChangeFunc = (e: {} | undefined) => {},
  inputValue = "",
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [textError, setTextError] = useState(textErr);

  useEffect(() => {
    setTextError(textErr);
  }, [textErr]);
  return (
    <Form.Group className={`custom-input ${inputSize} ${inputContainer}`}>
      {label != "" && (
        <Form.Label className={labelClassName}>{label}</Form.Label>
      )}
      <InputGroup>
        <Form.Control
          style={{ position: "relative" }}
          className={inputClassName}
          type={type != "password" ? type : showPassword ? "text" : "password"}
          placeholder={placeholder}
          disabled={activate == "disabled" ? true : false}
          readOnly={activate == "readOnly" ? true : false}
          plaintext={plaintext}
          as={inputType}
          isInvalid={textError == "" ? false : true}
          onChange={(e) => {
            onChangeFunc(e);
          }}
          value={inputValue}
        ></Form.Control>
        <Form.Control.Feedback type="invalid">
          {textError}
        </Form.Control.Feedback>
        {type == "password" &&
          (showPassword ? (
            <div
              className="d-flex align-items-center justify-content-center h-100"
              style={{ position: "absolute", width: 35, left: 5, zIndex: 9999 }}
            >
              {" "}
              <AiOutlineEye
                color="#677788"
                onClick={() => setShowPassword(false)}
                style={{ cursor: "pointer" }}
              />
            </div>
          ) : (
            <div
              className="d-flex align-items-center justify-content-center h-100"
              style={{ position: "absolute", width: 35, left: 5, zIndex: 9999 }}
            >
              <AiOutlineEyeInvisible
                color="#677788"
                onClick={() => setShowPassword(true)}
                style={{ cursor: "pointer" }}
              />
            </div>
          ))}
      </InputGroup>
    </Form.Group>
  );
};
const SeparatorInput: React.FC<{
  label?: string;
  placeholder?: string;
  inputSize?: "sm" | "lg" | "text" | undefined; //   lg/text/sm
  type: string; // text,number,password
  activate?: string; // disabled, readOnly, active
  plaintext?: boolean;
  inputType?: "input"; //input,textarea
  textErr?: string;
  labelClassName?: string;
  inputClassName?: string;
  inputContainer?: string;
  onChangeFunc?: (e: {}) => void;
  inputValue?: string;
  formatCustom: string;
  style: React.CSSProperties;
}> = ({
  label = "",
  placeholder = "",
  inputSize = "sm",
  activate = "active",
  plaintext = false,
  type = "",
  inputType = "input",
  style,
  textErr = "",
  labelClassName = "",
  inputClassName = "",
  inputContainer = "",
  onChangeFunc = (e: {} | undefined) => {},
  inputValue = "",
  formatCustom = "",
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [textError, setTextError] = useState(textErr);

  useEffect(() => {
    setTextError(textErr);
  }, [textErr]);
  return (
    <Form.Group className={`custom-input ${inputSize} ${inputContainer}`}>
      {label != "" && (
        <Form.Label className={labelClassName}>{label}</Form.Label>
      )}
      <div>
        <PatternFormat
          className={`form-control ${inputClassName}`}
          disabled={activate == "disabled" ? true : false}
          readOnly={activate == "readOnly" ? true : false}
          style={{
            border: plaintext
              ? "none"
              : textErr != ""
              ? "1px solid #dc3545"
              : "",
            ...style,
          }}
          placeholder={placeholder}
          onValueChange={(values) => {
            onChangeFunc(values);
          }}
          value={inputValue}
          format={formatCustom}
        />
        <span className="validate-style">{textError}</span>
      </div>
    </Form.Group>
  );
};

const ReactSelect: React.FC<{
  title?: string;
  itemsList?: [];
  inputContainer?: string;
  onChangeFunc: (e: [] | {} | null, action: {}) => void;
  inputValue: string;
  isMulti?: boolean;
  inputSize?: string; //text,lg
  textErr?: string;
  activate?: boolean; //true false
  isClearable?: boolean;
  style: React.CSSProperties;
  components?: {};
  placeholder: string;
  onInputChangeFunc: (value: string) => void;
}> = ({
  title = "",
  itemsList = [],
  inputContainer = "",
  onChangeFunc = (e: [] | {} | undefined, action: {}) => {},
  inputValue = "",
  isClearable = false,
  isMulti = false,
  inputSize = "text",
  textErr = "",
  activate = true,
  style,
  components = {},
  placeholder = "انتخاب کنید...",
  onInputChangeFunc = () => {},
}) => {
  return (
    <div
      className={`react-select ${textErr != "" && "validate-border"} ${
        !isMulti && inputSize
      } ${inputContainer}`}
      style={{ ...style }}
    >
      <label className="test" style={{ marginBottom: "0.5rem" }}>
        {title}
      </label>
      <Select
        options={itemsList}
        onChange={(e, action) => {
          if (e != null) onChangeFunc(e, action);
          else onChangeFunc([], action);
        }}
        value={inputValue}
        isMulti={isMulti}
        isDisabled={!activate}
        isClearable={isClearable}
        components={components}
        placeholder={placeholder}
        onInputChange={(value) => onInputChangeFunc(value)}
      />
      <div className="validate">{textErr}</div>
    </div>
  );
};
const CreatableReactSelect: React.FC<{
  title?: string;
  itemsList?: [];
  inputContainer?: string;
  onChangeFunc: (e: [] | {}) => void;
  inputValue: string;
  isMulti?: boolean;
  inputSize?: string; //text,lg
  textErr?: string;
  activate?: boolean; //true false
}> = ({
  title = "",
  itemsList = [],
  inputContainer = "",
  onChangeFunc = (e: [] | {} | undefined, action: {}) => {},
  inputValue = "",

  isMulti = false,
  inputSize = "text",
  textErr = "",
  activate = true,
}) => {
  return (
    <div
      className={`react-select ${textErr != "" && "validate-border"} ${
        !isMulti && inputSize
      } ${inputContainer}`}
    >
      <label className="test" style={{ marginBottom: "0.5rem" }}>
        {title}
      </label>
      <CreatableSelect
        options={itemsList}
        onChange={(e, action) => {
          if (e != null) onChangeFunc(e, action);
          else onChangeFunc([], action);
        }}
        value={inputValue}
        isMulti={isMulti}
        isDisabled={!activate}
      />
      <div className="validate">{textErr}</div>
    </div>
  );
};

const CheckInput: React.FC<{
  label?: string;
  inputValue?: boolean;
  inputContainer?: string;
  type?: "checkbox" | "radio" | "switch"; //checkbox,radio,switch
  name?: string;
  id?: string;
  onChangeFunc: (e: React.ChangeEvent<HTMLInputElement>) => void;
}> = ({
  label = "",

  inputContainer = "",
  type = "checkbox",
  name = "",
  id = "",
  onChangeFunc = () => {},
  inputValue = false,
}) => {
  return (
    <div className={`check-input ${inputContainer}`}>
      <div key={`default-${type}`}>
        <Form.Check
          className="d-flex align-items-center"
          type={type}
          name={name}
          id={id}
          label={label}
          // onClick={() => onChangeFunc()}
          onChange={(e) => {
            onChangeFunc(e);
          }}
          checked={inputValue}
        />
      </div>
    </div>
  );
};

const FileInput: React.FC<{
  label?: string;
  txt: string;
  iconTxt?: string;
  onChangeFunc: (e: {}) => void;
  id: string;
}> = ({
  txt = "",
  iconTxt = "انتخاب کنید...",
  id = "",
  onChangeFunc = (e: {} | undefined) => {},
  label = "",
}) => {
  return (
    <>
      <label
        htmlFor={id}
        className="w-100 file-input"
        onChange={(e) => onChangeFunc(e)}
      >
        <Form.Control type="file" id={id} hidden />
        <label style={{ marginBottom: "0.5rem" }}>{label}</label>
        <div
          className="d-flex justify-content-between align-items-center rounded-pill  p-1"
          style={{
            border: ` 2px solid #69809a`,
            // borderImage:
            //   "linear-gradient(to right, rgb(215, 215, 177), beige,rgb(226 226 197)) 1",
            // borderRadius: 20,
            fontSize: 14,
          }}
        >
          <div className="ms-2 me-1 main-text" style={{ height: 20 }}>
            {txt}
          </div>
          <div
            className="py-2 bg-warning rounded-pill px-3"
            style={{
              backgroundImage: `linear-gradient(to right, #69809a ,silver, silver,#69809a`,
              whiteSpace: "nowrap",
            }}
          >
            <span className="me-2 d-flex" style={{ fontSize: 12 }}>
              <span className="me-1"> {iconTxt}</span>

              <ImUpload2 color="#677788" />
            </span>
          </div>
        </div>
      </label>
    </>
  );
};
const FileInputSecond: React.FC<{
  label?: string;
  iconTxt?: string;
  onChangeFunc: (e: {}) => void;
  id: string;
  multiple: boolean;
  accept: string;
}> = ({
  iconTxt = "انتخاب کنید...",
  id = "",
  onChangeFunc = (e: {} | undefined) => {},
  label = "",
  multiple = false,
  accept = "*",
}) => {
  return (
    <>
      <label
        htmlFor={id}
        className="w-100 file-input"
        onChange={(e) => {
          console.log("object9999");
          onChangeFunc(e);
        }}
      >
        <Form.Control
          type="file"
          id={id}
          hidden
          multiple={multiple}
          accept={accept}
        />
        <label style={{ marginBottom: "0.5rem" }}>{label}</label>
        <div
          className="d-flex justify-content-between align-items-center rounded-pill  p-1"
          style={{
            border: ` 2px solid #69809a`,
            // borderImage:
            //   "linear-gradient(to right, rgb(215, 215, 177), beige,rgb(226 226 197)) 1",
            // borderRadius: 20,
            fontSize: 14,
          }}
        >
          <div
            className="py-2 bg-warning rounded-pill px-3 w-100"
            style={{
              backgroundImage: `linear-gradient(to right, #69809a ,silver, silver,#69809a`,
              whiteSpace: "nowrap",
              cursor: "pointer",
            }}
          >
            <span className="me-2 d-flex" style={{ fontSize: 12 }}>
              <span className="me-1"> {iconTxt}</span>

              <ImUpload2 color="#677788" className="ms-auto" />
            </span>
          </div>
        </div>
      </label>
    </>
  );
};
export {
  CustomInput,
  ReactSelect,
  CheckInput,
  FileInput,
  CreatableReactSelect,
  SeparatorInput,
  FileInputSecond,
};
